import type { NextPage } from "next";
import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import Loading from "~/components/common/parts/loading/Loading";
import { Page as Component } from "~/containers/specifics/todos/Page";

export const PATH = "/todos";

const TodosIndex: NextPage = () => {
	const router = useRouter();
	if (!router.isReady) return <Loading isLoading />;

	return (
		<>
			<NskHead title="TODO一覧" />
			<Component />
		</>
	);
};

export default TodosIndex;
